import momentTimezone from 'moment-timezone'
import store from '@/store'

export const dateViaTZ = date => {
  const currentTimezone =
  (store.state.auth.preferences && store.state.auth.preferences.timezone_offset && store.state.auth.preferences.timezone_offset !== undefined)
      ? store.state.auth.preferences.timezone_offset 
      : -4
  const d = date ? new Date(date) : new Date()
  const utc = d.getTime() + d.getTimezoneOffset() * 60000
  return new Date(utc + 3600000 * currentTimezone)
}


export const dateEST = date => {
  const d = date ? new Date(date) : new Date()
  const utc = d.getTime() + d.getTimezoneOffset() * 60000
  const estOffset = momentTimezone(d)
    .tz('America/Toronto')
    .utcOffset()
  return new Date(utc + 60000 * estOffset)
}
